import * as React from 'react'
const SvgEditPenSolid = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#60636B"
      d="M5.25 6.75a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V14a.75.75 0 0 1 1.5 0v4.75a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3H10a.75.75 0 0 1 0 1.5zM18.55 2.8a1.875 1.875 0 1 1 2.65 2.65l-1.1 1.1a1 1 0 0 0-.07-.08l-2.5-2.5a1 1 0 0 0-.08-.07z"
    />
    <path
      fill="#60636B"
      d="m16.4 4.95-8.47 8.468a4.5 4.5 0 0 0-1.13 1.897l-.536 1.8a.5.5 0 0 0 .622.621l1.799-.536a4.5 4.5 0 0 0 1.897-1.13l8.469-8.47a1 1 0 0 1-.081-.07l-2.5-2.5a1 1 0 0 1-.07-.08"
    />
  </svg>
)
export default SvgEditPenSolid
